import {Euler} from "three";

export class EaseHelper {
    // Linear easing: no easing, no acceleration
    static linear(t: number): number {
        return t;
    }

    // Quadratic ease-in: accelerating from zero velocity
    static easeIn(t: number): number {
        return t * t;
    }

    // Quadratic ease-out: decelerating to zero velocity
    static easeOut(t: number): number {
        return t * (2 - t);
    }

    // Quadratic ease-in-out: acceleration until halfway, then deceleration
    static easeInOut(t: number): number {
        t *= 2;
        if (t < 1) {
            return 0.5 * t * t;
        } else {
            return -0.5 * (--t * (t - 2) - 1);
        }
    }

    // Bounce easing: simulates a bouncing effect
    static bounce(t: number): number {
        if (t < 1 / 2.75) {
            return 7.5625 * t * t;
        } else if (t < 2 / 2.75) {
            t -= 1.5 / 2.75;
            return 7.5625 * t * t + 0.75;
        } else if (t < 2.5 / 2.75) {
            t -= 2.25 / 2.75;
            return 7.5625 * t * t + 0.9375;
        } else {
            t -= 2.625 / 2.75;
            return 7.5625 * t * t + 0.984375;
        }
    }

    // Moves t towards e by a maximum step of n
    static moveTowards(t: number, e: number, n: number): number {
        const delta = e - t;
        if (Math.abs(delta) <= n) {
            return e;
        } else {
            return t + Math.sign(delta) * n;
        }
    }

    // Linearly interpolates between two angles (in radians)
    static lerpAngleRadians(t: number, e: number, n: number): number {
        const pi = Math.PI;
        return t + ((e - t + pi + 2 * pi) % (2 * pi) - pi) * n;
    }

    // Linearly interpolates between two Euler angles
    static lerpEuler(t: Euler, e: Euler, n: number): Euler {
        const result = new Euler();
        result.x = this.lerpAngleRadians(t.x, e.x, n);
        result.y = this.lerpAngleRadians(t.y, e.y, n);
        result.z = this.lerpAngleRadians(t.z, e.z, n);
        result.order = t.order;
        return result;
    }
}
